import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Application } from '../../../core/app';
import {
  fetchRecurringPaymentsNumber, getPaymentMessage, requestDeleteAllSchedule,
  schedulePayment as requestSchedulepayment,
} from '../../../api/payment';
import { paymentFrequency } from '../../../helpers/app';
import { toUSD, checkDecimal } from '../../../helpers/formatters';
import moment from 'moment';
import { 
  ONLYONCE, TWICE_A_MONTH, PAYMENT_TYPE_CARD, PAYMENT_TYPE_ACH, PAYMENT_TYPE_PAD
} from '../../../constants/app';

// Import actions
import { setPaymentMethod, showLoading, hideLoading } from '../../../actions/app';
import { schedulePayment } from '../../../actions/schedule';

// Import components
import AchTermsConditions from '../../../components/payment/ach-terms-conditions';
import PadTermsConditions from '../../../components/payment/pad-terms-conditions';
import CongratulationsScheduleModal from '../../../components/schedule/congratulations-modal';
import DatePicker from 'react-datepicker';
import InfoModal from '../../../components/application/modals/info-modal';
import Modal from '../../../components/application/modal';
import Notice from '../../../components/application/notice';
import PayixButton from '../../../containers/payix-button';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

class ScheduleForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: '',
      isModalOpen: false,
      modal: null,
      modalWidth: '500px',
      notice: '',
      paymentFrequency: ONLYONCE,
      scheduleDate: null,
      scheduleDate2: null,
      paymentMessage: null,
      mustAcceptPaymentMessage: false,
      scheduleDetails: null,
    };

    getPaymentMessage()
    .then(response => {
      let dataResponse = response.data;
      if (dataResponse.result.paymentMessage != null) {
        this.state.paymentMessage = dataResponse.result.paymentMessage;
        this.state.mustAcceptPaymentMessage = true;
      }
    });
  }

  paymentsNumber = null;

  componentDidUpdate(prevProps) {
    // If the selected loan account has changed, then we clean the amount, scheduleDate2
    // and reset the paymentFrequecy to onlyonce.
    if (this.props.loanAccount.id !== prevProps.loanAccount.id) {
      this.setState({
        paymentFrequency: ONLYONCE,
        scheduleDate2: null,
        amount: (this.state.paymentFrequency === ONLYONCE) ? this.state.amount : ''
      });
    }
  }

  /**
   * Close the modal.
   */
  closeModal = () => {
    this.setState({
      isModalOpen: false,
      modal: null,
      modalWidth: '500px'
    });
  }

  acceptPaymentMessage = () => {
    this.setState({
      mustAcceptPaymentMessage: false,
    });
  };

  /**
   * Close the congratulations modal.
   */
  closeCongratulationsModal = () => {
    this.closeModal();
    this.props.onSuccess();
  }

  /**
   * Display the ach terms and conditions modal.
   */
  displayAchTermsConditionsModal() {
    this.setState({
      isModalOpen: true,
      modal: 'ACH_TERMS_CONDITIONS',
      modalWidth: '750px'
    });
  }

    /**
   * Display the ach terms and conditions modal.
   */
  displayPadTermsConditionsModal() {
    this.setState({
      isModalOpen: true,
      modal: 'PAD_TERMS_CONDITIONS',
      modalWidth: '750px'
    });
  }

  /**
   * Handler for on change event on the amount field.
   * 
   * @param event
   */
  handleChangeAmount = (event) => {
    this.setAmount(event.target.value);
  }

  /**
   * Set the new value for amount.
   * 
   * @param value
   */
  setAmount = (value) => {
    value = checkDecimal(value);

    if (value) {
      this.setState({amount: value[0]});
    }
  }

  /**
   * Get the total amount to pay.
   */
  getAmount() {
    let transactionFee = !this.props.transactionFee ? 0 : this.props.transactionFee;
    let amount = this.state.amount === '' ? 0 : this.state.amount;
    
    return parseFloat(amount) + transactionFee;
  }

  /**
   * Check if the form has all required fields full.
   */
  isFormFull() {
    let { amount, paymentFrequency, scheduleDate, scheduleDate2 } = this.state;
    let { selectedPaymentMethod } = this.props;
    if(amount > 0){
      if (this.state.paymentFrequency === TWICE_A_MONTH) {
        return (amount && selectedPaymentMethod && paymentFrequency && scheduleDate && scheduleDate2);
      }

      return (amount && selectedPaymentMethod && paymentFrequency && scheduleDate);
    }
  }

  /**
   * Set the selected payment frequency.
   * 
   * @param event
   */
  setPaymentFrequency = (event) => {
    let paymentFrequency = event.target.value;
    let amount = '';

    if (paymentFrequency !== ONLYONCE) {
      amount = this.props.loanAccount.regularPmtAmt;
    }

    this.setState({
      amount,
      paymentFrequency
    });
  }

  /**
   * Set the selected schedule date.
   * 
   * @param date
   */
  setScheduleDate = (date) => {
    this.setState({
      scheduleDate: date
    });
  }

  /**
   * Set the selected schedule date on blur event.
   * 
   */
  setScheduleDateOnBlur = ({target:{value}})=>{
    this.setState({
      scheduleDate: moment(value)
    });
  }

  /**
   * Set the selected schedule date 2.
   * 
   * @param date
   */
  setScheduleDate2 = (date) => {
    this.setState({
      scheduleDate2: date
    });
  }

  /**
   * Schedule a payment
   * 
   * @event
   */
  handleSchedulePayment = (event) => {
    event.preventDefault();

    let { amount, paymentFrequency } = this.state;
    let { loanAccount, selectedPaymentMethod } = this.props;
    if (this.isFormFull()) {
      if (selectedPaymentMethod.paymentType === PAYMENT_TYPE_CARD) {
        if (this.state.mustAcceptPaymentMessage) {
          this.setState({
            isModalOpen: true,
            modal: 'PAYMENT_METHOD',
            modalWidth: '750px'
          });
        } else {
          this.schedulePayment();
        }
      } else if (selectedPaymentMethod.paymentType === PAYMENT_TYPE_ACH) {
        if (paymentFrequency !== ONLYONCE) {
          this.props.showLoading();
  
          fetchRecurringPaymentsNumber({
            loanId: loanAccount.id,
            amount,
          }).then((response) => {
            let dataResponse = response.data;
    
            if (dataResponse.status === 1 && dataResponse.statusCode === 200) {
              // Append the payments number and show the term conditions modal.
              this.paymentsNumber = dataResponse.result.frequency;
              this.displayAchTermsConditionsModal();
            }
  
            this.props.hideLoading();
          }).catch(() => {
            Application.showInternalError();
          });
        } else {
          this.displayAchTermsConditionsModal();
        }
      }else if (selectedPaymentMethod.paymentType === PAYMENT_TYPE_PAD) {
        if (paymentFrequency !== ONLYONCE) {
          this.props.showLoading();
  
          fetchRecurringPaymentsNumber({
            loanId: loanAccount.id,
            amount,
          }).then((response) => {
            let dataResponse = response.data;
    
            if (dataResponse.status === 1 && dataResponse.statusCode === 200) {
              // Append the payments number and show the term conditions modal.
              this.paymentsNumber = dataResponse.result.frequency;
              this.displayPadTermsConditionsModal();
            }
  
            this.props.hideLoading();
          }).catch(() => {
            Application.showInternalError();
          });
        } else {
          this.displayPadTermsConditionsModal();
        }
      }
    }
  }

  /**
   * Schedule a payment for automatic recurring payment.
   */
  schedulePayment = () => {
    let { paymentFrequency, scheduleDate } = this.state;
    let { loanAccount, selectedPaymentMethod } = this.props;
    let scheduleDate2 = (this.state.paymentFrequency === TWICE_A_MONTH) ? this.state.scheduleDate2.format('YYYY-MM-DD') : '';
    let amount = this.getAmount();

    this.closeModal();
    this.props.showLoading();

    requestSchedulepayment({
      achTransactionFee: '',
      cardTransactionFee: 0,
      id: selectedPaymentMethod.id,
      loanAmount: parseFloat(amount).toFixed(2),
      loanId: loanAccount.id,
      paymentType: selectedPaymentMethod.paymentType,
      scheduleDate1: scheduleDate.format('YYYY-MM-DD'),
      scheduleDate2: scheduleDate2,
      type: paymentFrequency === ONLYONCE ? 1 : 2,
      pmtFreq: paymentFrequency
    })
    .then((response) => {
      let data = response.data;

      this.props.hideLoading();

      if (data.status === 0) {
        this.setState({
          isModalOpen: true,
          modal: 'NOTICE',
          notice: data.message
        });
      } else if (data.status === 1 && data.statusCode === 200) {
        this.setState({
          scheduleDate: null,
          paymentFrequency: ONLYONCE,
          amount: '',
          scheduleDetails: data.result.data,
          isModalOpen: true,
          modal: 'SUCCESSFUL_SCHEDULE'
        });
      }
    })
    .catch(() => {
      Application.showInternalError();
      this.props.hideLoading();
    });
  }

  /**
   * Show the modal confirmation before to remove all the 
   * current scheduled payments active.
   */
  showRemoveRecurringScheduleModal = () => {
    this.setState({
      isModalOpen: true,
      modal: 'REMOVE_RECURRING_SCHEDULE'
    });
  }

  /**
   * Remove all the current active scheduled payments.
   */
  removeRecurringSchedule = () => {
    this.closeModal();
    this.props.showLoading();

    requestDeleteAllSchedule(this.props.loanAccount.id)
      .then((response) => {
        let data = response.data;

        this.props.hideLoading();

        if (data.status === 1 && data.statusCode === 200) {
          Application.showSuccessMessage(data.message);
          this.props.onSuccess();
        } else {
          Application.showErrorMessage(data.message);
        }
      })
      .catch(() => {
        this.props.hideLoading();
        Application.showInternalError();
      })
  }

   /**
   * Map the response back when scheduling a payment and create props that are passed to the success modal.
   * 
   * @param {*} response 
   */
  mapResponseToPropsScheduleSuccessModal() {
    let { scheduleDetails } = this.state;
    let props = {};

    if (scheduleDetails !== null) {
      props = {
        frequency: scheduleDetails.paymentText,
        amount: toUSD(scheduleDetails.pmtAmt),
        amountWithFee: toUSD(parseFloat(this.getAmount()) + scheduleDetails.pmtAmt),
        lastFour: (scheduleDetails.paymentType === 1) 
        ? scheduleDetails.cardMethod.lastFour
        : (scheduleDetails.paymentType === 2)
        ? scheduleDetails.achMethod.lastFour
        : scheduleDetails.padMethod.lastFour,
        brand: (scheduleDetails.paymentType === 1) 
          ? scheduleDetails.cardMethod.cardBrand
          : (scheduleDetails.paymentType === 2)
          ? scheduleDetails.achMethod.bankName
          : scheduleDetails.padMethod.bankName,
        date: scheduleDetails.nextExecutionDate
      }
    }

    return props;
  }

  renderScheduleDate2(minDate) {
    if (this.state.paymentFrequency === TWICE_A_MONTH) {
      return (
        <div className="form-group loan-account__schedule-date">
          <label>{this.props.whiteLabel.labels['Schedule Date 2']}</label>
          <DatePicker
            selected={this.state.scheduleDate2}
            onChange={this.setScheduleDate2}
            className="datepicker"
            minDate={minDate}
          />
        </div>
      )
    }

    return null;
  }

  /**
   * Render the input for enter the amount.
   */
  renderAmountInput() {
    let extraProps = {};

    if (this.props.schedulePayment) {
      extraProps.disabled = this.props.frequency === ONLYONCE ? false : true
    }

    return (
      <input 
        className="money-input__textfield" 
        type="text" maxLength="13"
        value={this.state.amount} 
        onChange={this.handleAmount}
        {...extraProps} />
    )
  }

  /**
   * Render the Ach terms and contidions modal.
   * 
   * @param {*} data 
   */
  renderAchTermsAndConditionsModal() {
    let { client, selectedPaymentMethod } = this.props;

    let props = {
      amount: this.getAmount(),
      company: {
        name: client.legalCompanyName,
        website: client.website,
        phone: client.phoneNumber,
        workingHour: client.workingHour
      },
      isSchedule: true,
      lastFour: selectedPaymentMethod ? selectedPaymentMethod.lastFour : null,
      scheduleDate: this.state.scheduleDate.format('YYYY-MM-DD'),
      frequency: this.state.paymentFrequency,
      paymentsNumber: this.paymentsNumber,
      onSubmit: this.schedulePayment
    };

    return (
      <AchTermsConditions 
        {...props}
        onCancel={this.closeModal} />
    )
  }

  /**
   * Render the Ach terms and contidions modal.
   * 
   * @param {*} data 
   */
  renderPadTermsAndConditionsModal() {
    let { client, selectedPaymentMethod } = this.props;

    let props = {
      amount: this.getAmount(),
      company: {
        name: client.legalCompanyName,
        website: client.website,
        phone: client.phoneNumber,
        workingHour: client.workingHour
      },
      isSchedule: true,
      lastFour: selectedPaymentMethod ? selectedPaymentMethod.lastFour : null,
      scheduleDate: this.state.scheduleDate.format('YYYY-MM-DD'),
      frequency: this.state.paymentFrequency,
      paymentsNumber: this.paymentsNumber,
      onSubmit: this.schedulePayment
    };

    return (
      <PadTermsConditions 
        {...props}
        onCancel={this.closeModal} />
    )
  }

  renderModalContent() {
    if (this.state.mustAcceptPaymentMessage) {
      if (this.state.modal === 'ACH_TERMS_CONDITIONS' || this.state.modal === 'PAD_TERMS_CONDITIONS') {
        return (
            <InfoModal
                content={this.state.paymentMessage}
                leftButtonHandler={this.closeModal}
                rightButtonHandler={this.acceptPaymentMessage}
            />
        );
      } else if (this.state.modal === 'PAYMENT_METHOD') {
        return (
            <InfoModal
                content={this.state.paymentMessage}
                leftButtonHandler={this.closeModal}
                rightButtonHandler={this.schedulePayment}
            />
        );
      }
    }
    switch (this.state.modal) {
      case 'SUCCESSFUL_SCHEDULE' :
        return <CongratulationsScheduleModal
            {...this.mapResponseToPropsScheduleSuccessModal()}
            onClose={ this.closeCongratulationsModal } />
      case 'ACH_TERMS_CONDITIONS' :
        return this.renderAchTermsAndConditionsModal();
      case 'PAD_TERMS_CONDITIONS' :
        return this.renderPadTermsAndConditionsModal();
      case 'REMOVE_RECURRING_SCHEDULE' :
        return (
          <InfoModal
            content="Are you sure you want to delete all the scheduled payments?"
            leftButtonHandler={this.closeModal}
            rightButtonHandler={this.removeRecurringSchedule} />
        )
      case 'NOTICE' :
        return <Notice 
          message={this.state.notice}
          onClose={this.closeModal} />
      default :
        return null;
    }
  }

  /**
   * Render the component view.
   */
  render() {
    let minDate = moment().add(1, 'days');
    return (
      <div>
        <form onSubmit={this.handleSchedulePayment} className="load-account__payment-form">
          { this.props.paymentMethods }

          <div className="loan-account_schedule-fields">
            <div className="form-group loan-account__schedule-date">
              <label>{this.props.whiteLabel.labels['Schedule Date']}</label>
              <DatePicker
                selected={this.state.scheduleDate}
                onChange={this.setScheduleDate}
                onBlur={this.setScheduleDateOnBlur}
                className="datepicker"
                minDate={minDate}
              />
            </div>

            <div className="form-group loan-account__payment-frequency">
              <label>{this.props.whiteLabel.labels['Payment Frequency']}</label>
              <select 
                className="form-group__input custom-select" 
                onChange={this.setPaymentFrequency}
                value={this.state.paymentFrequency}>
                {this.props.client.allowAllBorrowerFrequencies ? (this.props.paymentFreqs.map((freq, index) => 
                (this.props.loanAccount.pmtFrequency === freq.payment_frequency) ? 
                (this.props.loanAccount.pmtFrequency !== 'S4' && freq.payment_frequency === 'S4') ? 
                 ('') : 
                 (<option key={index} value={freq.payment_frequency}>
                  *{freq.label}*
                </option>) : 
                ((this.props.loanAccount.pmtFrequency !== 'S4') && (freq.payment_frequency === 'S4')) ?
                ('') : 
                (((this.props.loanAccount.pmtFrequency === 'S4') && (freq.payment_frequency === 'SM')) ? 
                ('') : 
                (<option key={index} value={freq.payment_frequency}>
                  {freq.label}
                </option>) 
                ))):(<option value={this.props.loanAccount.pmtFrequency}>
                  {paymentFrequency(this.props.loanAccount.pmtFrequency)}
                </option>)}
                <option value={ONLYONCE}>Only Once</option>
              </select>
            </div>

            {this.renderScheduleDate2(minDate)}
          </div>

          <div className="form-group">
            <label className="load-account__money-amount">Enter amount you would like to pay</label>
            <div className="money-input">
              <span className="money-input__addon">
                <i className="fas fa-dollar-sign"></i>
              </span>

              {/**
                ** Render the input for the amount.
                **/}
              <input 
                className="money-input__textfield" 
                type="text" 
                maxLength="13"
                value={this.state.amount}
                disabled={this.props.editAmount?false:this.state.paymentFrequency !== ONLYONCE ? true : false}
                onChange={this.handleChangeAmount} />
            </div>
          </div>

          {/**
            ** Show the convenience fee if apply. 
            **/}
            {(this.props.transactionFee)
            ? (
              <div className="load-account__total">
                <span>
                  Convenience Fee&nbsp;
                  <Tooltip placement="top" overlay={this.props.transactionMargin}>
                    <i className="fas fa-info-circle color-green op-4"></i>
                  </Tooltip>
                </span>
                <span className="color-red">{toUSD(this.props.transactionFee)}</span>
              </div>
            )
            : null
          }

          <div className="load-account__total">
            <span className="gothammedium-font">{this.props.whiteLabel.labels['Total Payable']}</span>
            <span className="gothammedium-font">{toUSD(this.getAmount())}</span>
          </div>

          <PayixButton 
            className="button--full"
            type="submit"
            disabled={!this.isFormFull()}>
            {this.props.whiteLabel.labels['schedule a payment']} {toUSD(this.getAmount())}
          </PayixButton>

          {this.props.showRemoveRecurring
            ? this.props.hasRecurring
              ? this.props.delete
                ? (
                  <button
                    className="button button--full button--transparent"
                    type="button"
                    onClick={this.showRemoveRecurringScheduleModal}>
                    Remove Recurring All Schedules
                  </button>
                )
                : null
              : null
            : null
          }
        </form>

        <Modal 
          isOpen={this.state.isModalOpen}
          width={this.state.modalWidth}
          onClose={this.closeModal}>

          {this.renderModalContent()}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    client: state.client.data,
    paymentFreqs: state.client.paymentFreqs,
    transactionFee: state.app.payment.transactionFee,
    transactionMargin: state.client.transactionMargin,
    whiteLabel:state.whiteLabel
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    setPaymentMethod, showLoading, hideLoading, schedulePayment
  }, dispatch);
}
 
export default connect(mapStateToProps, mapDispatchToProps)(ScheduleForm);


// WEBPACK FOOTER //
// ./src/components/application/loan-account/schedule-form.js